var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root",style:({
    width: _vm.containerSize.width + 'px',
    height: _vm.containerSize.height + 'px',
  })},[_c('img',{staticClass:"bg",style:({ top: _vm.imgOffset.top + 'px', left: _vm.imgOffset.left + 'px' }),attrs:{"width":_vm.imgSize.width,"height":_vm.imgSize.height,"src":_vm.imgSrc,"alt":"bakgrunnseffekt"}})])}
var staticRenderFns = []

export { render, staticRenderFns }